export enum RentalAgencyChangeStatusEnum {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export const rentalAgencyChangeStatusColorMap: Record<RentalAgencyChangeStatusEnum, string> = {
  [RentalAgencyChangeStatusEnum.Pending]: '#FFD889',
  [RentalAgencyChangeStatusEnum.Approved]: '#C1FFEA',
  [RentalAgencyChangeStatusEnum.Rejected]: '#FFA39E',
};
